import NavigationController from './navigation.controller';
import NavigationService from './services/navigation.service';
import MenuTogglerDirective from './directives/menu-toggler.directive';

angular
	.module('app.navigation', [])
	.component('appNavigation', {
		templateUrl: 'layout/navigation/navigation.html',
		controller: NavigationController,
		bindings: {
			$router: '<'
		}
	})
	.service('navigationService', NavigationService)
	.directive('menuToggler', MenuTogglerDirective);
